/**
 * Constants for Plan Guide feature.
 *
 * @see frontend/workspace/CU-868gzzjua/frontend_research.md
 * @see frontend/workspace/CU-868gzzjua/frontend_implementation_guide.md
 */

import type { GuideSession } from './types';

// API endpoints
export const API_BASE_PATH = '/api/v1/plan-guide';

// Page IDs
export const PAGE_IDS = {
  HUB: 'hub',
  GOALS: 'goals',
  ASSETS: 'assets',
  RECOMMENDATIONS: 'recommendations',
  FIX: 'fix',
  COMPARISON: 'comparison',
} as const;

export type PageId = (typeof PAGE_IDS)[keyof typeof PAGE_IDS];

// Actions
export const ACTIONS = {
  GOALS: 'goals',
  ASSETS: 'assets',
  RECOMMENDATIONS: 'recommendations',
  FIX: 'fix',
  APPLY_CHANGES: 'apply_changes',
  ACCEPT: 'accept',
  REJECT: 'reject',
  BACK: 'back',
} as const;

export type ActionType = (typeof ACTIONS)[keyof typeof ACTIONS];

// localStorage
export const STORAGE_KEY_PREFIX = 'planGuide';
export const SESSION_EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours

// Initial state
export const INITIAL_SESSION: GuideSession = {
  currentPageId: PAGE_IDS.HUB,
  formData: {},
  visitedPages: [],
};
